export const initState = {
  homeResources: {}
};
